// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"ddd0b953","453":"670e15c7"}[chunkId] + ".chunk.js";
};